import { render, staticRenderFns } from "./BillingPlansBikyCards.vue?vue&type=template&id=2bc7eda0&"
import script from "./BillingPlansBikyCards.vue?vue&type=script&lang=ts&"
export * from "./BillingPlansBikyCards.vue?vue&type=script&lang=ts&"
import style0 from "./BillingPlansBikyCards.vue?vue&type=style&index=0&id=2bc7eda0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports